export enum Constants {
  SUCCESS = "success",
  ERROR = "error",
  FAILED = "failed",
  TACTICAL_MIN = "tacticalMin",
  TACTICAL_MAX = "tacticalMax",
  VIEW = "view",
  ADD = "add",
  EDIT = "edit",
  DELETE = "delete",
  SELECT = "select",
  INPUT = "input",
  DATE_PICKER = "datePicker",
  CHECKBOX = "checkbox",
  TIME_PICKER = "timePicker",
  LOGIN_KEY = "login",
  OTP = "otp",
  TEXTAREA = "textarea",
  ACTIVE = "Active",
  INACTIVE = "Inactive",
  TURE = "true",
  BULK = "Bulk",
  I = "I",
  N = "N",
  D = "D",
  X = "X",
  F = "F",
  S = "S",
  DEL = "DEL",
  ZERO = "0",
  ONE = "1",
  TWO = "2",
  DAY = "day",
  LAST_DAY = "lastDay",
  MONTH = "month",
  FORT_NIGHT = "fortNight",
  MULTIPLE = "multiple",
  FALSE = "false",
  LATEST_SUB = "latest_sub",
  LAST_4_SUB = "last_4_sub",
  WEEK = "week",
  RUN = "run",
  RESET = "reset",
  ALL = "All",
  Y = "Y",
  J = "J",
  SAVE = "save",
  DISPLAY = "display",
  SAVE_RECORD = "saveRecord",
  ONE_THIRTY = 130,
  ZERO_INT = 0,
  LOADING = "loading",
  ENTER = "Enter",
  SAVER = "saver",
  INFO = "Info"
}

export enum DataActionKeys {
  MESSAGE_MODAL = "messageModal",
  MESSAGE = "message",
  MESSAGE_STATUS = "messageStatus",
  CONFIRM_MODAL = "confirmModal",
  QUICK_ACTION_MODAL = "quickActionModal",
  DELETE_MODAL = "deleteModal",
  MODULE_ACCESS = "moduleAccess",
  API_STATUS_MODAL = "apiStatusModal",
  LOGGER_ID = "loggerId",
  MASS_ACTION_MODAL = "massActionModal",
  PENDING = "Pending",
  DATA = "data",
  CHECKBOX_LIST = "checkBoxList",
  REDIRECT = "Redirect"
}

export enum ScreenName {
  FARE_UPDATE_QUERY = "fareUpdateQuery",
  FARE_CLONE_QUERY = "fareCloneQuery",
  AUTO_PILOT_QUERY = "autoPilotQuery",
  WORK_PACKAGE_QUERY = "workPackageQuery",
  PROMOTION_FAREREVIEW = "promotion_farereview",
  FARE_DASHBOARD = "faredashboard",
  PRICE_PERFORMANCE_QUERY = "pricePerformanceQuery",
  FOOTNOTE_ASSIGNMENT = "footnoteAssignment",
  FARE_REVIEW = "farereview",
  FARE_MANAGEMENT = "fareManagement",
  WORK_PACKAGE = "Workpackage",
  FARE_LADDER_MAPPING = "Fare_Ladder_Mapping",
}

export enum StringConstants {
  DEPARTURE_DATE = "Departure Date:",
  DEPARTURE_PERIOD = "Departure Period",
  DEPARTURE_DATE_ = "departureDate:",
  DEP_DATE_START = "dep_date_start",
  DEP_DATE_END = "dep_date_end",
  ID = "ID",
  LWk = "LWk",
  LY = "LY",
  LAST_YEAR = "Last Year",
  TARGET_YIELD = "Target Yield:",
  YIELD_LAST_YEAR = "Yield Last Year:",
  FMS = "FMS:",
  TRIGGER_CLASS = "trigger_class",
  BKGS_LAST_YEAR = "Bkgs Last Year",
  LOW = "low",
  TWK = "TWk",
  CY = "CY",
  TY = "TY",
  THIS_YEAR = "This Year",
  YIELD = "Yield:",
  MS = "MS:",
  HIGH = "high",
  YIELD_THIS_YEAR = "Yield This Year:",
  THRESHOLD = "threshold",
  THRESHOLDS = "Thresholds",
  OLD_VALUES = "oldValues",
  NEW_VALUES = "newValues",
  RAISED_ON = "Raised On",
  RAISED = "raised",
  TO = "to",
  INF = "inf",
  FCR = "FCR",
  COMPETITOR_MATCH = "Competitor Match",
  SELL_UP = "Sellup",
  COMPETITOR = "Competitor",
  OPPORTUNITIES = "Opportunities",
  REACHED_MAX_LEVEL = "Reached max level",
}

export enum Symbol {
  COLON = ":",
  PLUS = "+",
  MINUS = "-",
  BRACKET = "[",
  DOT = ".",
}

export enum MongoKeys {
  $EXISTS = "$exists",
  $OR = "$or",
  $AND = "$and",
  $NIN = "$nin",
  $NOT = "$not",
  $ELEMMATCH = "$elemMatch",
  $EQ = "$eq",
}
export enum FbrCat35ComponentKeys {
  FBRCAT35_FORM = "fbrCat35Form",
  SFI = "sfi",
  SHORTSFI = "shortSfir"
}

export enum ApprovalFlowKeys {
  FORWARD = "forward",
  SEND_BACK = "sendBack",
  DELETE = "delete",
  FILE = "file",
  Processing = "Processing",
  RULE_PACKAGE = "rule_package",
  WORK_PACKAGE = "work_package",
  CREATE = "create",
}
export enum FareManagement {
  FARES_LENGTH = 1000,
}

